module.exports = __webpack_public_path__ + "static/Banco-fb0f0fb14d565cf938aad97c222ac6b1.jpg";